import { Helmet } from "react-helmet-async";

const ORG_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "NonprofitOrganization",
  name: "Tales&Legends gUG",
  url: "https://talesandlegends.org",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Dresden",
    addressCountry: "DE",
  },
};

export default function OrganizationJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ORG_JSON_LD)}</script>
    </Helmet>
  );
}
